<template>
  <div>
    <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
    <b-navbar class="navbar" toggleable="lg">
      <router-link to="/"><b-navbar-brand><img class ="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand></router-link>
    </b-navbar>
    <!-- <div class="container p-5">
      <div class="text-right" v-if="$history.length > 0">
       
      </div>
      <div>
        
      </div>
    </div> -->
    <div class="ctm-container">
      <b-row>
        <b-col cols="12" sm="12" md="12">
          <h3 :class="styleClasses">{{ getMetaTitle }}</h3>
          <router-view class="mt-4"></router-view>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BContainer, BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BNavItem } from 'bootstrap-vue'
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'

export default {
  mixins: [layoutMixin, gtagMixin],
  props: {
    backVisible: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    'loading-anim': () => import('@/components/utils/LoadingAnim'),
    BContainer,
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem
  },
  methods: {
    back () {
      window.history.back()
    }
  },
  computed: {
    styleClasses () {
      return (this.$route.meta && this.$route.meta.title) ? (this.$route.meta.title.styleClasses || '') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ctm-container {
    @include container-padding;
    h3 {
      color: black
    }
}

@include mobile {
  /deep/ .navbar-brand {
      margin-right: 0;
  }
  /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: transparent !important;
    display: flex;
  }
  .navbar {
    padding: 1rem 2rem;
    
    .btn-layout{
     font-size: .875rem !important;
     font-weight: initial;
     padding: .7rem 2.2rem;
     background-color: $blue;
    }
  }
}

/deep/ .nav-item {
  margin-right: 0rem;
  @include mobile {
    padding: 0rem;
  }
}

/deep/ .navbar-brand-img {
  width: 150px;
}

/* .navbar {
  @include mobile {
    padding: 1rem;
  }
} */

/deep/.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
/deep/.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/layouts/InternalReducedLayout.vue